<template>
  <div
    v-tooltip="{ content: userName }"
    class="user-avatar"
  >
    <span>{{ initials }}</span>
  </div>
</template>

<script>
export default {
  name: 'XUserAvatar',
  props: {
    userName: {
      type: String,
      required: true
    }
  },

  computed: {
    initials () {
      const initials = this.userName.match(/\b\w/g) || []
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
    }
  }
}
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .user-avatar {
    height: 3rem;
    width: 3rem;
    border: 2px solid #FFFFFF;
    background: #E5EAF5;
    font-size: 1.2rem;
    font-weight: 600;
    border-radius: 50%;
    color: $color-galaxy;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    user-select: none;
  }
</style>